import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddStopsTutorialPage } from './add-stops-tutorial.page';

const routes: Routes = [
  {
    path: '',
    component: AddStopsTutorialPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddStopsTutorialPageRoutingModule {}
